import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Tooltip } from "@mui/material";
import React, { memo } from "react";

interface IconBtnProps extends React.CSSProperties {
    title: string;
    icon: IconProp;
    disabled?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const IconBtn: React.FC<IconBtnProps> = memo(({ icon, title, onClick, disabled, ...iconStyle }) => {
    return (
        <IconButton onClick={onClick} disabled={disabled}>
            <Tooltip title={title}>
                <FontAwesomeIcon icon={icon} style={iconStyle} />
            </Tooltip>
        </IconButton>
    );
});

export default IconBtn;
